import { Action } from 'store/store';
import NetworkState from 'communication/NetworkState';
import { AnyAction } from 'redux';

export enum RootActionType {
    RESET_STATE = 'ROOT_RESET_STATE',
}

export interface ResetStateActionPayload {
    networkDownState: NetworkState;
}

export type ResetStateAction = Action<
    RootActionType.RESET_STATE,
    ResetStateActionPayload
>;

export const resetStateAction = (
    payload?: ResetStateActionPayload
): ResetStateAction => ({
    type: RootActionType.RESET_STATE,
    payload,
});

export function isResetStateAction(
    action: AnyAction
): action is ResetStateAction {
    const a = action as ResetStateAction;
    return a.type === RootActionType.RESET_STATE;
}
